import React from "react";
import { createRoot } from "react-dom/client";

import AssetFileForm, { AssetFileFormAPI } from "./AssetFileForm";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".sponsor_events_form").forEach((formElem) => {
    const form = formElem as HTMLFormElement;
    const errorElem = form.querySelector(".submit_error") as HTMLDivElement;

    form
      .querySelectorAll(".sponsor_events_form_asset_file")
      .forEach((elem_) => {
        const elem = elem_ as HTMLDivElement;
        const dest = elem.querySelector(".sponsor_events_form_asset_file_form");

        const fileIdElem = elem.querySelector(
          'input[type=hidden][name="sponsor_event[asset_file_id]"]',
        ) as HTMLInputElement;
        if (!fileIdElem) return;

        const existingFileId =
          fileIdElem.value.length > 0 ? fileIdElem.value : null;

        const sessionEndpoint = elem.dataset.sessionEndpoint;
        const sessionEndpointMethod = elem.dataset.sessionEndpointMethod;
        if (!sessionEndpoint || !sessionEndpointMethod) return;

        const componentRef = React.createRef<AssetFileFormAPI>();

        if (!dest) {
          console.error(
            "Destination element not found for event AssetFileForm",
          );
          return;
        }

        const root = createRoot(dest);
        root.render(
          <AssetFileForm
            ref={componentRef}
            needUpload={false}
            existingFileId={existingFileId}
            sessionEndpoint={sessionEndpoint}
            sessionEndpointMethod={sessionEndpointMethod}
            accept="image/png,image/jpeg,image/webp"
            removable={!!existingFileId}
          />,
        );

        form.addEventListener("submit", async function (e) {
          e.preventDefault();
          form
            .querySelectorAll("input[type=submit]")
            .forEach((el) => ((el as HTMLInputElement).disabled = true));
          try {
            if (errorElem) errorElem.classList.add("d-none");

            if (!componentRef.current) {
              throw new Error("AssetFileForm ref is not available");
            }

            const fileId = await componentRef.current.ensureUpload();
            if (fileId !== null) {
              fileIdElem.value = fileId;
              form.submit();
              return;
            }

            form
              .querySelectorAll("input[type=submit]:disabled")
              .forEach((el) => ((el as HTMLInputElement).disabled = false));
          } catch (e) {
            if (errorElem) {
              errorElem.innerHTML = `ERROR: ${e}`;
              errorElem.classList.remove("d-none");
            }
            form
              .querySelectorAll("input[type=submit]:disabled")
              .forEach((el) => ((el as HTMLInputElement).disabled = false));
            throw e;
          }
        });
      });
  });
});
